export default __webpack_public_path__ + "static/media/new.f16ecdf6.svg";